import { serialize } from "./search-serializer.js";
export function $path(args) {
    const trailingSlash = args.trailingSlash ?? false;
    let url = args.to;
    if (trailingSlash) {
        url += "/";
    }
    if (args.params !== undefined) {
        for (const [paramKey, paramValue] of Object.entries(args.params)) {
            url = url.replace(`[${paramKey}]`, paramValue.toString());
        }
    }
    if (args.search) {
        const search = serialize(args.search);
        url += `?${search.toString()}`;
    }
    const searchParams = new URLSearchParams(args?.searchParams);
    if (searchParams.size > 0 && !args.search) {
        url += `?${searchParams.toString()}`;
    }
    if (args.hash !== undefined) {
        const hash = args.hash.startsWith("#") ? args.hash.slice(1) : args.hash;
        url += `#${hash}`;
    }
    return url;
}
